import React, { useState, useEffect } from "react";
import "./LanguageButton.css"; // Add styles for the button and dropdown

const availableLanguages = {
    en: "English",
    "zh-TW": "中文（繁體）",
    "zh-CN": "中文（简体）",
    ja: "日本語",
    fr: "Français",
    de: "Deutsch",
    es: "Español",
    it: "Italiano",
    ru: "Русский",
    pt: "Português",
    ar: "العربية",
    hi: "हिन्दी",
};

export default function LanguageButton() {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState("en");

    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleLanguageChange = (lang) => {
        setSelectedLanguage(lang);
        setIsOpen(false);
        localStorage.setItem("preferredLang", lang);
        const googleCombo = document.querySelector(".goog-te-combo");
        if (googleCombo) {
            googleCombo.value = lang;
            googleCombo.dispatchEvent(new Event("change"));
        }
    };

    useEffect(() => {
        const preferredLang = localStorage.getItem("preferredLang");
        if (preferredLang && preferredLang !== "en") {
            setSelectedLanguage(preferredLang);
        }
    }, []);

    return (
        <div className="language-button">
            <button className="lang-btn notranslate goog-te-no-trans" onClick={toggleDropdown}>
                🌐 {"  "} {availableLanguages[selectedLanguage]}
            </button>
            {isOpen && (
                <ul className="lang-dropdown notranslate goog-te-no-trans">
                    {Object.keys(availableLanguages).map((lang) => (
                        <li
                            key={lang}
                            className={lang === selectedLanguage ? "selected" : ""}
                            onClick={() => handleLanguageChange(lang)}
                        >
                            {availableLanguages[lang]}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}